import styled from 'styled-components6';
import { SourceIcon } from '../SourceIcon';
import { Body1, ThemeBreakpoint, mqDown } from '../../theme';
import { HTMLProps } from 'react';
import { Model } from 'rwl-shared';
import { renderStars } from '../../components/ReviewStars/renderStars';

export interface ReviewTotalBoxProps {
    count: number;
    rating: number;
    breakpoint?: ThemeBreakpoint;
    source?: Model.ContentSource | ('GMB' | 'Facebook');
}

const Container = styled.span`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: fit-content;
`;

const SIZE = '12px';

const RatingWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const StarContainer = styled.span<{ $breakpoint?: ThemeBreakpoint }>`
    flex-direction: row;
    justify-content: center;
    display: flex;
    margin: 0 8px;

    ${({ $breakpoint }) => `${$breakpoint && mqDown($breakpoint)} {
        display: none;
    }`}
`;

const RatingNumber = styled(Body1)`
    color: #00000099;
    margin-right: var(--rwl-spacing-sm);
`;

const ReviewCount = styled(Body1)`
    color: #00000099;
`;

export const GoogleAggregateChip = ({
    source,
    rating,
    breakpoint,
    count,
    ...rest
}: ReviewTotalBoxProps &
    Omit<HTMLProps<HTMLDivElement>, 'children' | 'ref' | 'as'>) => {
    if (count === 0) {
        return null;
    }
    return (
        <Container {...rest} className={'reviewTotal_' + source}>
            <RatingWrapper>
                <SourceIcon
                    source={source}
                    style={{
                        width:
                            source === 'Internal'
                                ? `calc(${SIZE} * 2)`
                                : `calc(${SIZE} * 1.5)`,
                        height:
                            source === 'Internal'
                                ? `calc(${SIZE} * 2)`
                                : `calc(${SIZE} * 1.5)`,
                    }}
                />
                <StarContainer $breakpoint={breakpoint}>
                    {renderStars(rating)}
                </StarContainer>{' '}
                <RatingNumber>{rating?.toFixed(1)} </RatingNumber>
                <ReviewCount>({count})</ReviewCount>
            </RatingWrapper>
        </Container>
    );
};
